export default "__VITE_ASSET__DyCoeKGT__"